<div class="home-background">
    <div class="blur"></div>
</div>
<div mat-card class='txp-home__card'>
    <div class="home-card-image"></div>
    <div class="home-card-content">
        <div mat-card-title class="txp-home__logo">
        </div>
        <div mat-card-content class="txp-home__content">
            <div class="content-welcome">WELCOME!</div>
            <div class="content-message">Log in to your TCE account</div>
            <txp-button
                data-qa-label="LogInButton"
                [style]="buttonStyle.PRIMARY"
                (click)="login()">
                Log In
            </txp-button>
        </div>
    </div>
</div>
